import React, { FC, useEffect } from 'react';

import { ErrorExceptionType } from '../../containers/appContextContainer';
import { pushErrorToDataLayer } from '../../util/gtm/gtm-service';
import UserMessageError from './userMessageError';
import UserMessageNotFound from './userMessageNotFound';
import UserMessageSystemUnavailable from './userMessageSystemUnavailable';
import UserMessageTimeout from './userMessageTimeout';

interface Props {
    error: ErrorExceptionType;
}

const UserMessageException: FC<Props> = ({ error }) => {
    useEffect(() => {
        if (error) {
            pushErrorToDataLayer(error.errorType, error.errorException);
        }
    }, [error]);
    if (error.errorException) {
        switch (error.errorException.status) {
            case 401:
                return <UserMessageTimeout />;
            case 404:
                return <UserMessageNotFound />;
            case 503:
                return <UserMessageSystemUnavailable />;
            default:
                return <UserMessageError />;
        }
    } else {
        return <></>;
    }
};

export default UserMessageException;
